import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  Avatar,
  CircularProgress,
  Button,
  List,
  ListItem,
  ListItemText,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  Link,
} from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { connect } from 'react-redux';
import { TenantService } from '@pingum/api-services';
import { redirectToSubdomain } from '../../../../utils/tenantAuthenticationHelper';
import { leaveTenant } from '../../../../redux/user/actions';
import propTypes from '../../../../utils/propTypes';
import Tenant from '../../../widgets/Tenant';

import './styles.scss';

const styles = (theme) => ({
  item: {
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: theme.spacing(1),
    paddingLeft: 0,
    paddingRight: 0,
  },
});

export class UserTenantsListComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openConfirmLeaveTenantDialog: false,
      selectedTenantToLeave: null,
    };
  }

  handleClickOpen = (tenant) => {
    this.setState({
      openConfirmLeaveTenantDialog: true,
      selectedTenantToLeave: tenant,
    });
  }

  handleClose = () => {
    this.setState({
      openConfirmLeaveTenantDialog: false,
      selectedTenantToLeave: null,
    });
  }

  handleCloseConfirm = () => {
    this.props.leaveTenant(this.state.selectedTenantToLeave.name);
    this.setState({
      openConfirmLeaveTenantDialog: false,
      selectedTenantToLeave: null,
    });
  }

  render() {
    const {
      classes,
      isFetching,
      tenants,
    } = this.props;

    return (
      <div>
        <List>
          <Paper elevation={10}>
            <ListItem
              button
              component={Link}
              to="/create-organization"
              href="/create-organization"
            >
              <Avatar>
                <Add />
              </Avatar>
              <ListItemText
                primary="Create an organization"
              />
            </ListItem>
          </Paper>

          {
            !!isFetching
            && (
              <div className={classes.loadingContainer}>
                <CircularProgress />
              </div>
            )
          }
          {
            !isFetching
              && tenants.map((tenant) => {
                const tenantUrl = TenantService.getTenantUrl(tenant.name);
                return (
                  <Paper className={classes.item} key={tenant.name} elevation={10}>
                    <Tenant
                      key={tenant.name}
                      tenant={{
                        ...tenant,
                        tenantUrl,
                      }}
                      onClick={() => {
                        redirectToSubdomain({
                          tenant: tenant.name,
                          redirect: '/dashboards',
                        });
                      }}
                      secondaryActionOnClick={() => {
                        this.handleClickOpen(tenant);
                      }}
                      secondaryActionIcon="delete_sweep"
                    />
                  </Paper>
                );
              })
          }
        </List>

        <Dialog
          open={this.state.openConfirmLeaveTenantDialog}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Confirm Action</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to leave the organization {
                this.state.selectedTenantToLeave === null
                  ? ''
                  : this.state.selectedTenantToLeave.displayName
              }? This action cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { this.handleClose(); }}>
              Cancel
            </Button>
            <Button onClick={() => { this.handleCloseConfirm(); }} color="secondary" variant="contained" autoFocus>
              Leave Organization
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

UserTenantsListComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  tenants: PropTypes.arrayOf(propTypes.tenant),
  isFetching: PropTypes.bool.isRequired,
  leaveTenant: PropTypes.func.isRequired,
};

UserTenantsListComponent.defaultProps = { tenants: [] };

export const mapStateToProps = (state) => ({
  tenants: state.user.tenants,
  isFetching: state.user.isFetchingUserTenants,
});

export const mapDispatchToProps = (dispatch) => ({ leaveTenant: (tenantName) => dispatch(leaveTenant(tenantName)) });

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(UserTenantsListComponent));
